<script setup lang="ts">
import { computed, ref, onMounted } from 'vue';
import type { IColumnDefinition, RowData, INumberColumn } from '../types';
import { useNumberMask } from '../../forms/useNumberMask';

const props = defineProps<{
  modelValue: any;
  row: RowData;
  column: IColumnDefinition;
  autofocus?: boolean;
}>();
const emit = defineEmits<{
  (event: 'update:modelValue', value: number | null): void;
  (event: 'input', value: number | null): void;
  (event: 'change', value: number | null): void;
}>();
const inputRef = ref<HTMLInputElement | null>(null);

const col = computed(() => props.column as INumberColumn);

useNumberMask(
  inputRef,
  {
    get modelValue() {
      return props.modelValue;
    },
    unmask: 'typed',
    scale: 'any',
  },
  emit,
);

onMounted(() => {
  if (props.autofocus) {
    inputRef.value?.focus();
  }
});
</script>

<template>
  <input
    ref="inputRef"
    type="text"
    inputmode="decimal"
    class="form-control form-control-sm text-end"
    :name="col.name"
    :placeholder="col.placeholder"
    :disabled="col.editorIsDisabled ? col.editorIsDisabled(row) : false"
    @change="emit('change', modelValue)"
    @click.stop
  />
</template>
